import { IconPlus } from "@tabler/icons-react";
import React from "react";
import { Button } from "@components/ui/button";
import { cn } from "@lib/utils";

const WidgetContainerPlace = () => (
  <div className="group flex min-h-50 items-center justify-center rounded-xl border border-dashed hover:border-muted-foreground">
    <Button variant="ghost" size="icon" className="hidden group-hover:flex">
      <IconPlus />
    </Button>
  </div>
);

const defaultWidgetsContainerLayoutClassName =
  "grid auto-rows-min grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3";

export const WidgetsContainer = ({
  children,
  className,
  layoutClassName = defaultWidgetsContainerLayoutClassName,
  withoutWidgetPlace,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & {
  layoutClassName?: string;
  withoutWidgetPlace?: boolean;
}) => {
  const childrenArray = React.Children.toArray(children);
  const childrenCount = childrenArray.length;

  // If no children, show one empty placeholder
  if (childrenCount === 0) {
    return (
      <div {...props} className={cn(layoutClassName, className)}>
        <WidgetContainerPlace />
      </div>
    );
  }

  // If there are children, show only one empty placeholder
  return (
    <div {...props} className={cn(layoutClassName, className)}>
      {children}
      {!withoutWidgetPlace && <WidgetContainerPlace />}
    </div>
  );
};
